import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import constructionCover from "../../../assets/tendering/create/construction.webp";
import designCover from "../../../assets/tendering/create/design.webp";
import { Button } from "../../../components";
import { useNavigate } from "react-router-dom";
import CreateTenderingContext, {
  TENDERING_CREATE_STEPS,
} from "./CreateTenderingContext";
import _ from "lodash";

const SelectType = (props) => {
  const navigate = useNavigate();
  const { goBackward, goForward, details, setDetails, setCurrentStep } =
    useContext(CreateTenderingContext);

  useEffect(() => {
    setCurrentStep(TENDERING_CREATE_STEPS.SELECT);
  }, []);

  const [selectedType, setSelectedType] = useState(details?.type);

  useEffect(() => {
    setDetails((curr) => ({ ...curr, type: selectedType }));
  }, [selectedType]);

  const _getCardClass = (type) => {
    if (type === selectedType)
      return "tendering-create__select-type__types__card tendering-create__select-type__types__card--active";

    return "tendering-create__select-type__types__card";
  };

  const handleGoForward = () => {
    goForward();
  };

  return (
    <div className="tendering-create__select-type">
      <h3>Create Tendering</h3>
      <div className="tendering-create__select-type__types">
        <div className={_getCardClass(1)} onClick={() => setSelectedType(1)}>
          <img
            className="tendering-create__select-type__types__card__image"
            src={designCover}
          />
          <div className="tendering-create__select-type__types__card__overlay" />
          <span className="tendering-create__select-type__types__card__text">
            Design
          </span>
        </div>
        <div className={_getCardClass(2)} onClick={() => setSelectedType(2)}>
          <img
            className="tendering-create__select-type__types__card__image"
            src={constructionCover}
          />
          <div className="tendering-create__select-type__types__card__overlay" />
          <span className="tendering-create__select-type__types__card__text">
            Construction
          </span>
        </div>
      </div>
      <div className="tendering-create__select-type__footer">
        <Button
          label="Back"
          variant={"secondary"}
          onClick={() => goBackward()}
        />
        <Button
          label="Next"
          disabled={!selectedType}
          onClick={handleGoForward}
        />
      </div>
    </div>
  );
};

SelectType.propTypes = {};

export default SelectType;
